import { HTMLAttributes } from 'react';
import styles from './PlayButton.module.scss';
import { classes } from '../../../lib/utils/cssUtils';

const PlayButton = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={classes(styles.container, className)}>
    <div className={styles.button} />
    <div className={styles.polygon} />
  </div>
);

export default PlayButton;
